import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import usePlans from "../hooks/usePlans";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import ApiOficialDocs from "../pages/ApiOficialDocs/";
import TestInteractive from "../pages/TestInteractive/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import Companies from "../pages/Companies/";
import Wallets from "../pages/Wallets/";
import QuickMessages from "../pages/QuickMessages/";
import CreateWhatsAppTemplate from "../pages/CreateWhatsAppTemplate";
import WhatsAppTemplates from "../pages/WhatsAppTemplates";
import EditWhatsAppTemplate from "../pages/EditWhatsAppTemplate";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { WebphoneProvider } from "../context/Webphone/WebphoneContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections/";
import Reports from "../pages/Reports";
import RelatorioVendas from "../pages/RelatorioVendas";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files/";
import AiAssets from "../pages/AiAssets";
import ToDoList from "../pages/ToDoList/";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import DashboardTags from "../pages/DashboardTags";
import BirthdaySettingsPage from "../pages/BirthdaySettings";
import CallHistoricals from "../pages/CallHistoricals";
import Holidays from "../pages/Holidays";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/FlowBuilder";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import OfficialCampaigns from "../pages/OfficialCampaigns";
import OfficialCampaignReport from "../pages/OfficialCampaignReport";
import CampaignsPro from "../pages/CampaignsPro/";
import CampaignProReport from "../pages/CampaignProReport/";
import ContactListProItems from "../pages/ContactListProItems/";
import Floup from "../pages/Floup/";
import FloupDashboard from "../pages/FloupDashboard/";
import StatusPage from "../pages/Status/";
import SuperAdmin from "../pages/SuperAdmin/";
import AuditLogs from "../pages/AuditLogs/";
import CompanyDeletionProgress from "../components/CompanyDeletionProgress";
import BrowserNotifications from "../pages/BrowserNotifications";
import KanbanEnterprise from "../pages/KanbanEnterprise";
import GroupManagement from "../pages/GroupManagement";
import GroupsList from "../pages/GroupManagement/GroupsList";
import GroupNew from "../pages/GroupManagement/GroupNew";
import GroupEdit from "../pages/GroupManagement/GroupEdit";
import GroupEditForm from "../pages/GroupManagement/GroupEditForm";
import GroupParticipants from "../pages/GroupManagement/GroupParticipants";
import Broadcast from "../pages/GroupManagement/Broadcast";
import FlowBuilderV2 from "../pages/FlowBuilderV2";
import Connect from "../pages/Connect";
import ForgotPassword from "../pages/ForgotPassword";

const RoutesContent = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showGroupManagement, setShowGroupManagement] = useState(false);
  const [showPhraseListFlow, setShowPhraseListFlow] = useState(true);
  const [showConversationFlow, setShowConversationFlow] = useState(true);
  const [showFollowUp, setShowFollowUp] = useState(true);
  const { user } = useContext(AuthContext);
  const { getPlanCompany } = usePlans();

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  useEffect(() => {
    if (!user?.companyId) return;
    getPlanCompany(undefined, user.companyId)
      .then((planConfigs) => {
        if (planConfigs?.plan?.useCampaigns) {
          setShowCampaigns(true);
        }
        if (planConfigs?.plan?.useGroupManagement) {
          setShowGroupManagement(true);
        }
        setShowPhraseListFlow(planConfigs?.plan?.usePhraseListFlow !== false);
        setShowConversationFlow(planConfigs?.plan?.useConversationFlow !== false);
        setShowFollowUp(planConfigs?.plan?.useFollowUp !== false);
      })
      .catch(() => {});
  }, [user?.companyId, getPlanCompany]);

  // Verificar se a empresa está vencida
  const isCompanyExpired = () => {
    if (!user || !user.company || user.company.id === 1) {
      return false; // Empresa ID 1 nunca expira
    }

    const dueDate = user.company.dueDate;
    if (!dueDate) return false;

    // Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
    const hojeInicio = moment().startOf('day');
    const vencimentoInicio = moment(dueDate).startOf('day');

    // Empresa está vencida apenas após o dia do vencimento
    return hojeInicio.isAfter(vencimentoInicio, 'day');
  };

  return (
    <TicketsContextProvider>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/conectar/:token" component={Connect} isPublic />
        <WebphoneProvider>
          <WhatsAppsProvider>
            <LoggedInLayout hideMenu={isCompanyExpired()}>
            <Route
              exact
              path="/financeiro"
              component={Financeiro}
              isPrivate
            />

            <Route
              exact
              path="/financeiro-aberto"
              component={Financeiro}
              isPrivate
            />

            <Route
              exact
              path="/companies"
              component={Companies}
              isPrivate
            />
            <Route
              exact
              path="/super-admin"
              component={SuperAdmin}
              isPrivate
            />
            <Route
              exact
              path="/birthday-settings"
              component={BirthdaySettingsPage}
              isPrivate
            />
            <Route
              exact
              path="/holidays"
              component={Holidays}
              isPrivate
            />
            <Route
              exact
              path="/audit-logs"
              component={AuditLogs}
              isPrivate
            />
            {showGroupManagement && (
              <>
                <Route exact path="/group-management" component={GroupManagement} isPrivate />
                <Route exact path="/group-management/groups" component={GroupsList} isPrivate />
                <Route exact path="/group-management/groups/new" component={GroupNew} isPrivate />
                <Route exact path="/group-management/groups/edit" component={GroupEdit} isPrivate />
                <Route exact path="/group-management/groups/:groupId/edit" component={GroupEditForm} isPrivate />
                <Route exact path="/group-management/groups/:groupId/participants" component={GroupParticipants} isPrivate />
                <Route exact path="/group-management/broadcast" component={Broadcast} isPrivate />
              </>
            )}
            <Route exact path="/" component={Dashboard} isPrivate />
            <Route exact path="/call-historicals" component={CallHistoricals} isPrivate />
            <Route
              exact
              path="/tickets/:ticketId?"
              component={TicketResponsiveContainer}
              isPrivate
            />
            <Route
              exact
              path="/connections"
              component={Connections}
              isPrivate
            />
            <Route
              exact
              path="/quick-messages"
              component={QuickMessages}
              isPrivate
            />
            <Route
              exact
              path="/whatsapp-template-create"
              component={CreateWhatsAppTemplate}
              isPrivate
            />
            <Route
              exact
              path="/whatsapp-templates"
              component={WhatsAppTemplates}
              isPrivate
            />
            <Route
              exact
              path="/whatsapp-templates/:whatsappId/:templateId/edit"
              component={EditWhatsAppTemplate}
              isPrivate
            />
            <Route
              exact
              path="/status"
              component={StatusPage}
              isPrivate
            />
            <Route exact path="/todolist" component={ToDoList} isPrivate />
            <Route
              exact
              path="/schedules"
              component={Schedules}
              isPrivate
            />
            <Route exact path="/tags" component={Tags} isPrivate />
            <Route exact path="/contacts" component={Contacts} isPrivate />
            <Route
              exact
              path="/contacts/import"
              component={ContactImportPage}
              isPrivate
            />
            <Route exact path="/wallets" component={Wallets} isPrivate />
            <Route exact path="/helps" component={Helps} isPrivate />
            <Route exact path="/users" component={Users} isPrivate />
            <Route
              exact
              path="/messages-api"
              component={MessagesAPI}
              isPrivate
            />
            <Route
              exact
              path="/api-oficial-docs"
              component={ApiOficialDocs}
              isPrivate
            />
            <Route
              exact
              path="/test-interactive"
              component={TestInteractive}
              isPrivate
            />
            <Route
              exact
              path="/settings"
              component={Settings}
              isPrivate
            />
            <Route
              exact
              path="/browser-notifications"
              component={BrowserNotifications}
              isPrivate
            />
            <Route exact path="/queues" component={Queues} isPrivate />
            <Route exact path="/reports" component={Reports} isPrivate />
            <Route
              exact
              path="/relatorio-vendas"
              component={RelatorioVendas}
              isPrivate
            />
            <Route
              exact
              path="/queue-integration"
              component={QueueIntegration}
              isPrivate
            />
            <Route
              exact
              path="/announcements"
              component={Annoucements}
              isPrivate
            />
            <Route exact path="/chats/:id?" component={Chat} isPrivate />
            <Route exact path="/files" component={Files} isPrivate />
            <Route
              exact
              path="/moments"
              component={ChatMoments}
              isPrivate
            />
            <Route exact path="/Kanban" component={Kanban} isPrivate />
            <Route exact path="/kanban-enterprise" component={KanbanEnterprise} isPrivate />
            <Route
              exact
              path="/TagsKanban"
              component={TagsKanban}
              isPrivate
            />
            <Route
              exact
              path="/dashboard-tags"
              component={DashboardTags}
              isPrivate
            />
            <Route exact path="/prompts" component={Prompts} isPrivate />
            <Route exact path="/ai-assets" component={AiAssets} isPrivate />
            <Route
              exact
              path="/allConnections"
              component={AllConnections}
              isPrivate
            />

            {showFollowUp && (
              <>
                <Route
                  exact
                  path="/plugins/floup"
                  component={Floup}
                  isPrivate
                />
                <Route
                  exact
                  path="/plugins/floup/dashboard"
                  component={FloupDashboard}
                  isPrivate
                />
              </>
            )}

            {showPhraseListFlow && (
              <Route
                exact
                path="/phrase-lists"
                component={CampaignsPhrase}
                isPrivate
              />
            )}
            {showConversationFlow && (
              <>
                <Route
                  exact
                  path="/flowbuilders"
                  component={FlowBuilder}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilder-v2/:id?"
                  component={FlowBuilderV2}
                  isPrivate
                />
              </>
            )}

            {showCampaigns && (
              <>
                <Route
                  exact
                  path="/contact-lists"
                  component={ContactLists}
                  isPrivate
                />
                <Route
                  exact
                  path="/contact-lists/:contactListId/contacts"
                  component={ContactListItems}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns"
                  component={Campaigns}
                  isPrivate
                />
                <Route
                  exact
                  path="/official-campaigns"
                  component={OfficialCampaigns}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaign/:campaignId/report"
                  component={CampaignReport}
                  isPrivate
                />
                <Route
                  exact
                  path="/official-campaigns/:id/report"
                  component={OfficialCampaignReport}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns-config"
                  component={CampaignsConfig}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns-pro"
                  component={CampaignsPro}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns-pro/:campaignId/report"
                  component={CampaignProReport}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns-pro/lists/:contactListProId"
                  component={ContactListProItems}
                  isPrivate
                />
              </>
            )}
          </LoggedInLayout>
            </WhatsAppsProvider>
        </WebphoneProvider>
      </Switch>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        style={{ zIndex: 10004 }}
        toastStyle={{ zIndex: 10004 }}
      />
      <CompanyDeletionProgress />
    </TicketsContextProvider>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
